import React from 'react'
import connect from 'libraries/front-end-core/decorators/connect'
import { requestFlavouredQASections } from 'services/QAService'
import { $userAolPreferences } from 'services/SessionService'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import QAMenu from './Main'
import { ALL_FLAVOURS } from 'constants/flavours'
import { requestUserFavourites } from 'services/FavouritesService'

const ConnectedQAMenu = connect((props) => ({
  qaSections: requestFlavouredQASections(ALL_FLAVOURS),
  favourites: requestUserFavourites('qa'),
  order: $userAolPreferences
}))((props) => {
  return (
    <ResponseConsumer
      responses={[props.qaSections, props.order, props.favourites]}
      skeleton='aol-tiled-menu'
      content={() => <QAMenu {...props} />}
    />
  )
})

export default ConnectedQAMenu
